// @ts-ignore
// eslint-disable-next-line no-unused-vars
import {IServiceBookState} from './service-book-state.store'
import {ActionTree} from 'vuex'
import {IRootState} from '../root-state.store'
// @ts-ignore
import * as _ from './service-book-types.store'



export const actions: ActionTree<IServiceBookState, IRootState> = {
  [_.SERVICEBOOK_GET_SERVICEBOOKS]: ({commit, state, getters},infiniteHandlerState:any) => {
    commit(_.SERVICEBOOK_SET_ISLOADING,true)
    console.log(getters.searchParams)
    getters.service.getServiceBooks({...getters.searchParams, $skip:getters.serviceBooks.length}).then((response:any)=>{
      if (response !== undefined) {
        commit(_.SERVICEBOOK_SET_COUNT,{free:response.free,used:response.used})
        if (response.total > 0 && getters.serviceBooks.length <= response.total) {
          let concatList = getters.serviceBooks.concat(response.data)
          commit(_.SERVICEBOOK_SET_SERVICEBOOKS, concatList)
        }
      }
      if (infiniteHandlerState !== undefined) {
        infiniteHandlerState.loaded()
        if (response !== undefined) {
          if (getters.serviceBooks.length >= response.total) {
            infiniteHandlerState.complete()
          }
        }
      } else {
        infiniteHandlerState.reset()
      }
    }).finally(()=>{
      commit(_.SERVICEBOOK_SET_ISLOADING,false)
    })
  },

  [_.SERVICEBOOK_GET_SERVICEBOOK]: async ({commit, state, getters},id:string) => {
    commit(_.SERVICEBOOK_SET_ISLOADING,true)
    return getters.service.getServiceBookById(id).then((response:any)=>{
      console.log(response)
      commit(_.SERVICEBOOK_SET_SERVICEBOOK, response)
    }).finally(()=>{
      commit(_.SERVICEBOOK_SET_ISLOADING,false)
    })
  },

  [_.SERVICEBOOK_PATCH_SERVICEBOOK]: async ({commit, state, getters},payload:{id:string,apartment:any, fk_apartment:number}) => {
    const body:{apartment?:any, fk_apartment?:number} = {}
    if(payload.fk_apartment) { body.fk_apartment = payload.fk_apartment}
    if(payload.apartment) { body.apartment = payload.apartment}
    return getters.service.associateServiceBook(payload.id, body)
  }
}



// WEBPACK FOOTER //
// ./src/store/service-book/service-book-action.store.ts